import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";
import { EstudianteActivoCard } from "./EstudianteActivoCard";

const POR_PAGINA = 15;

export const EstudianteActivoList = ({ estudiantes = [] }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const { objetosEnPagina, paginas, paginaInicial, paginaFinal } = paginacion(
    paginaActual,
    estudiantes,
    POR_PAGINA
  );

  const columnas = [
    "#",
    "Nombre",
    "Apellido",
    "Código",
    "Teléfono",
    "Tipo de Admision",
    "Grupo",
    "Género",
    "Credito",
    "Opciones",
  ];

  const mostrar = objetosEnPagina?.length > 0;

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {mostrar ? (
        objetosEnPagina.map((estudiante, i) => (
          <EstudianteActivoCard
            key={estudiante?.estudiante?.idEstudiante || i}
            estudiante={estudiante}
            index={(paginaActual - 1) * POR_PAGINA + i}
          />
        ))
      ) : (
        <tr>
          <td colSpan={columnas.length} className="text-center py-4">
            No hay estudiantes activos
          </td>
        </tr>
      )}
    </DataTable>
  );
};

export default EstudianteActivoList;